import React, { Component } from 'react';
import { connect } from 'react-redux';
import { OutputEmailEdit } from './components';

import { Form } from '@ant-design/compatible';


import { Row } from 'antd';

import {
    getPagePermissions,
    CONFIG_APPLICATION
} from '../../security/permissions';

class OutputEmailConfig extends Component {

    render() {
        return (
            <Row>
                <OutputEmailEdit />
            </Row>
        );
    }

}

const OutputEmailConfigForm = Form.create({ name: 'outputEmailConfig' })(OutputEmailConfig);


const mapStateToProps = ({ userData, userData: { permissions } }) => {
    return {
        userData,
        exportReportsPermissions: getPagePermissions(CONFIG_APPLICATION, permissions)
    };
};

export default connect(mapStateToProps)(OutputEmailConfigForm);
